import Vuetable from 'vuetable-2/src/components/Vuetable';
import email from 'vuelidate/src/validators/email';
import Avatar from '@/components/Avatar/Avatar';
import Avatars from '@/components/Avatars';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import Input from '@/components/Input/Input';
import Label from '@/components/Label/Label';
import CustomTable from '@/components/Table';
import Pagination from '@/components/Pagination';
import sort from '@/utils/Sort';
import arraysData from '@/utils/ArraysData';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import Topic from '@/models/strategy/Topic';
import { mapActions, mapGetters } from 'vuex';
import ToastWrapper from '@/components/ToastWrapper/ToastWrapper';
import MultiSelectSearch from '../../MultiSelectSearch/MultiSelectSearch';
import GroupMemberTable from '@/components/tables/GroupMemberTable';

export default {
  name: 'GroupTable',
  components: {
    Vuetable,
    Avatar,
    Avatars,
    Button,
    Input,
    Modal,
    Label,
    ToastWrapper,
    MultiSelectSearch,
    Pagination,
    GroupMemberTable,
    CustomTable
  },
  props: ['groups', 'members'],
  data() {
    return {
      reset: false,
      currentPage: 1,
      paginationItems: 10,
      sortOrder: 'asc',
      sortColumn: 'name',
      selectedGroups: [],
      selected: [],
      selectionOriginal: [],
      selectionGroup: '',
      single: {
        item: {},
        candidateText: '',
        original: null
      },
      modal: {
        delete: {
          single: false,
          multiple: false
        },
        update: false,
        create: false,
        users: false
      },
      newGroup: {
        name: ''
      },
      currentList: [],
      columns: [
        { name: '', type: 'AvatarText', key: 'name' },
        { name: 'Name', type: 'Default', key: 'name', has_sort: true },
        { name: 'Users', type: 'AvatarMulti', key: 'members' },
        { name: 'Themes', type: 'LabelListColor', key: 'topics' }
      ],
      actions: [
        { icon: 'people', method: this.usersAction },
        { icon: 'edit', method: this.updateSingle },
        { icon: 'delete', method: this.deleteSingle }
      ]
    };
  },
  computed: {
    paging() {
      const start = (this.currentPage - 1) * this.paginationItems;

      return {
        start: start,
        end: start + this.paginationItems
      };
    },
    sortedGroups() {
      return sort(this.groups, this.sortColumn, this.sortOrder).slice(
        this.paging.start,
        this.paging.end
      );
    },
    iconDirection() {
      return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down';
    },
    allSelected() {
      return (
        this.selectedGroups.length === this.sortedGroups.length &&
        this.sortedGroups.length
      );
    },
    deleteCandidateText() {
      return this.selectedGroups.length === 1
        ? this.selectedGroups[0].email
        : `${this.selectedGroups.length} groups`;
    },
    isNewValid() {
      return this.newGroup.name.trim().length > 0;
    },
    isDeleting: function() {
      return this._isDeleting();
    },
    isUpdating: function() {
      return this._isUpdating();
    },
    searchThemes() {
      const topics = Topic.query()
        .orderBy('name')
        .get()
        .map(topic => {
          return { id: topic.id, name: `Topic: ${topic.name}`, type: 'topic' };
        });

      const options = [
        {
          groupName: 'Topics',
          groupValues: topics
        }
      ];

      return options;
    }
  },
  methods: {
    ...mapActions({
      _newToast: 'toasts/_addToast',
      _groupRemove: 'entities/groups/remove',
      _groupCreate: 'entities/groups/create',
      _groupUpdate: 'entities/groups/update',
      _groupMembers: 'entities/groups/members'
    }),
    ...mapGetters({
      _isDeleting: 'entities/groups/isDeleting',
      _isUpdating: 'entities/groups/isUpdating'
    }),
    resetPage() {
      this.selectedGroups = [];
      this.reset = true;
    },
    onMultiAction(value) {
      this.selected.push(value);
    },
    sortOn(column) {
      if (column === this.sortColumn) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
    },
    select(value) {
      if (this.selectedGroups.includes(value)) {
        this.selectedGroups = this.selectedGroups.filter(current => {
          return current !== value;
        });
      } else {
        this.selectedGroups.push(value);
      }
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedGroups = [];
      } else {
        this.sortedGroups.map(member => {
          if (!this.selectedGroups.includes(member)) {
            this.selectedGroups.push(member);
          }
        });
      }
    },
    isSelected(value) {
      return this.selectedGroups.includes(value) ? 'checked' : '';
    },
    closeCreateModal() {
      this.modal.create = false;
      this.newGroup.name = '';
    },
    deleteSingle(value) {
      this.single.candidateText = value.name;
      this.single.item = value;
      this.modal.delete.single = true;
    },

    updateSingle(value) {
      this.single.candidateText = value.name;
      this.single.item = Object.assign({}, value);
      this.single.original = value;
      this.currentList = value.topics.map(topic => {
        return { id: topic.id, name: topic.name };
      });

      this.single.original.topic_list = value.topics.map(topic => {
        return topic.id;
      });

      this.modal.update = true;
    },

    updateSingleAction() {
      this.single.original.name = this.single.item.name;
      this.single.original.theme_list = this.currentList.map(theme => {
        return theme.id;
      });

      const data = arraysData(
        this.single.original.theme_list,
        this.single.original.topic_list
      );

      const payload = { group: this.single.item, values: data };

      this._groupUpdate(payload).then(() => {
        this._newToast({
          text: 'Group has been successfully updated',
          variant: 'good',
          duration: 2000
        });
        this.single.item = null;
        this.single.original = null;
        this.modal.update = false;
      });
    },
    deleteSingleAction() {
      this._groupRemove([this.single.item]).then(() => {
        this.single.candidateText = '';
        this.single.item = null;
        this.modal.delete.single = false;

        this._newToast({
          text: 'Group has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    deleteSelectionAction() {
      this._groupRemove(this.selectedGroups).then(() => {
        this.modal.delete.multiple = false;

        if (this.allSelected) {
          this.updateCurrentPage(1);
        } else {
          this.selectedGroups = [];
        }

        this._newToast({
          text: 'Group has been successfully removed',
          variant: 'good',
          duration: 2000
        });
      });
    },
    createAction() {
      this._groupCreate(this.newGroup).then(() => {
        this.modal.create = false;
        this.newGroup.name = '';

        this._newToast({
          text: 'Group has been created',
          variant: 'good',
          duration: 2000
        });
      });
    },
    usersAction(value) {
      this.selectionGroup = value.id;
      this.selected = value.members.map(member => {
        return member.id;
      });

      this.selectionOriginal = value.members.map(member => {
        return member.id;
      });

      this.modal.users = true;
    },
    updateGroupUsers() {
      const data = {
        group: this.selectionGroup,
        values: arraysData(this.selected, this.selectionOriginal)
      };

      this._groupMembers(data).then(() => {
        this._newToast({
          text: 'Group has been successfully updated',
          variant: 'good',
          duration: 2000
        });

        this.modal.users = false;
      });
    },
    updateCurrentPage(currentPage) {
      this.selectedGroups = [];
      this.currentPage = currentPage;
      this.reset = false;
    }
  }
};
